import type { LoaderFunction, RouteObject } from 'react-router-dom'

import {
	setActiveSide,
	setIdActive
} from 'components/molecules/leftSideMenu/loader'

import { ContactsPage } from './Page'

const setId: LoaderFunction = args => setIdActive(args, 'id')

export const Route: RouteObject[] = [
	{
		Component: ContactsPage,
		loader: () => setActiveSide(1),
		path: '/contacts'
	},
	{ Component: ContactsPage, loader: setId, path: '/contacts/import/:id' }
]
